module.exports = __webpack_public_path__ + "static/media/image (22).d89baa03.jpg";